import { createDelete, createGet, createPost, createPut } from './ajax';

export const addGuest = createPost({
  path: params => `/events/${params.event_id}/guests`,
  csrf: true,
  json: true,
});

export const fetchEvent = createGet({
  path: params => `/api/v1/events/${params.event_id}`,
  forcedParams: {
    include_design_info: true,
  },
});

export const fetchEventDelivery = createGet({
  path: params => `/api/v1/events/${params.event_id}/guests`,
});

export const newEvent = createGet({
  path: '/api/v1/packages/template',
  allowedParams: ['package_id'],
  forcedParams: {
    include_design_info: true,
  },
});

export const sendEvent = createPut({
  path: params => `/events/${params.event_id}/email_cards`,
  allowedParams: ['contact_list'],
  forcedParams: {
    // you laugh ... I weep.
    // this is literally what the rails app does to version itself.
    app_version: 'www_' + new Date().getTime(),
  },
  json: true,
  csrf: true,
});

export const updateEventDetails = createPut({
  path: params => `/events/${params.event_id}/details`,
  allowedParams: ['from', 'subject'],
  forcedParams: {
    fromAndSubject: true,
  },
  json: true,
  csrf: true,
});

export const removeGuest = createDelete({
  path: params => `/api/v1/guests/${params.guest_id}`,
  allowedParams: ['guest_id', 'event_id'],
});

export const fetchPrice = createPost({
  path: '/api/v1/pricing/by_cards',
  allowedParams: ['event_id'],
  forcedParams: {
    mode: 'online',
  },
  json: true,
});
